/**
 * A function that handles returning human readable file sizes.
 */
export function toMemorySize(bytes: number) {
  const kilobytes = bytes / 1024;

  if (kilobytes < 1) {
    return bytes.toString() + "B";
  }

  const megabytes = kilobytes / 1024;

  if (megabytes < 1) {
    return kilobytes.toFixed(0).toString() + " KB";
  }

  return megabytes.toFixed(0).toString() + " MB";
}
